/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AgentInfo } from './AgentInfo';
import {
    AgentInfoFromJSON,
    AgentInfoFromJSONTyped,
    AgentInfoToJSON,
    AgentInfoToJSONTyped,
} from './AgentInfo';

/**
 * Response model for the agents endpoint.
 * @export
 * @interface AgentsResponse
 */
export interface AgentsResponse {
    /**
     * 
     * @type {Array<AgentInfo>}
     * @memberof AgentsResponse
     */
    agents: Array<AgentInfo>;
}

/**
 * Check if a given object implements the AgentsResponse interface.
 */
export function instanceOfAgentsResponse(value: object): value is AgentsResponse {
    if (!('agents' in value) || value['agents'] === undefined) return false;
    return true;
}

export function AgentsResponseFromJSON(json: any): AgentsResponse {
    return AgentsResponseFromJSONTyped(json, false);
}

export function AgentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'agents': ((json['agents'] as Array<any>).map(AgentInfoFromJSON)),
    };
}

export function AgentsResponseToJSON(json: any): AgentsResponse {
    return AgentsResponseToJSONTyped(json, false);
}

export function AgentsResponseToJSONTyped(value?: AgentsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'agents': ((value['agents'] as Array<any>).map(AgentInfoToJSON)),
    };
}

